<div class="modal md:w-[450px] max-h-[95vh] overflow-auto [&&]:pt-10">
  <label class="flex flex-wrap gap-3 modal-body-text [&&]:font-normal mb-0">
    <h1 class="modal-title [&&]:text-base leading-2">
      {{ 'thereIsSomethingWrongWithTheReportedTransaction' | translate }}
    </h1>
    <hr class="spacement" />
    <label class="font-normal mb-0" [innerHTML]="getAwareText()"></label>
  </label>
  <hr class="spacement" />
  <div class="modal-buttons-wrapper flex [&&]:justify-end">
    <app-nicky-button variant="primary" id="yes-send" class="clickable" (click)="dialogRef.close(false)">
      {{ 'close' | translate }}
    </app-nicky-button>
  </div>
</div>
